export default "__VITE_ASSET__BakEzEgN__"